import { jsx as t } from "react/jsx-runtime";
const l = "", i = ({
  isDisabled: e,
  ...o
}) => /* @__PURE__ */ t("option", { disabled: e, ...o }), s = ({
  ...e
}) => /* @__PURE__ */ t(i, { value: l, isDisabled: !0, ...e });
export {
  s as PlaceholderSelectOption,
  i as SelectOption,
  l as defaultOptionValue
};
